export const COLOR_BROWN = "#DEC8B6";
export const LIGHT_SHADOW = "4px 20px 40px rgba(203, 202, 209, 0.2)";
export const SCORE_RANKING_COLORS = { 1: "warning.500", 2: "greyscale.500", 3: COLOR_BROWN };
